export default __webpack_public_path__ + "static/media/Q15.4a90935b.jpg";